
<div class="main-section tryagain-page text-center">
    <img src="https://images.5paisa.com/SPOT/activation/try-again.png" />
    @if((panName != "" || bankName != "") && (panName != undefined || bankName != undefined)){
        <div class="mis--match">
            <div class="t--info"> Name Mismatch Identified </div>
            <table>
                <tbody class="t--body">
                    <tr>
                        <td> As per PAN</td>
                        <td>{{panName}}</td>
                    </tr>
                    <tr>
                        <td> As per BANK</td>
                        <td> {{bankName}}</td>
                    </tr>
                </tbody>
        </table> <br>

            <!-- <span>Name as per PAN : {{panName}}</span><br>
            <span>Name as per BANK : {{bankName}}</span><br><br> -->
        </div>
    }
    @if(respStatus == 8){
        <div class="mis--match">
            <div class="t--info">PAN Mismatch</div>
            <table>
                <tbody class="t--body">
                    <tr>
                        <td>As per 5Paisa record</td>
                        <td>{{clientPan}}</td>
                    </tr>
                    <tr>
                        <td>As per BANK</td>
                        <td> {{bankPan}}</td>
                    </tr>
                </tbody>
        </table> <br>

            <!-- <span>Name as per PAN : {{panName}}</span><br>
            <span>Name as per BANK : {{bankName}}</span><br><br> -->
        </div>
    }


    <div class="msg--info" [innerHTML]="respMsg"></div>
    <div class="button-wrapper">
        @if(misMatchStatus != 0 || respStatus == 2 ){
            <button type="button" class="btn--transparent" [disabled]="btnLoader" (click)="clickOnNo()">{{btnTxt2}}</button>
        }
        <button type="button" class="btn--primary" *ngIf="!btnLoader" (click)="clickOnYes()">{{btnTxt}}</button>
        <button #loaderBtn class="button btn--primary" *ngIf="btnLoader">
            <span class="stage">
                <span class="dot-pulse"></span>
            </span>
        </button>
    </div>
    @if(respStatus == 0 || misMatchStatus == 0){
        <div  class="bottom-button-wrapper btn" (click)="documentUploadBottomSheet()">
            <span>Switch to Other Income Proof types</span>
        </div>
    }
</div>